
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"flexibleSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"flexibleSection_NeoField"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleWysiwyg"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleFullwidthImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleFAQ"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleLinks"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleTextImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleVideo"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleLinkCards"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleTeamBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleNews"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleProgrammes"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleCases"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleProminentText"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleImages"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleProjectsOrPortfolios"},"directives":[]}]}}],"loc":{"start":0,"end":1446}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/flexibleSections/flexibleWysiwyg.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleFullwidthImage.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleFAQ.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleVideo.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleLinks.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleTextImage.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleLinkCards.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleTeamBlock.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleNews.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleProgrammes.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleCases.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleProminentText.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleImages.graphql\"\n#import \"~/graphql/fragments/flexibleSections/flexibleProjectsOrPortfolios.graphql\"\n\nfragment flexibleSections on flexibleSection_NeoField {\n    __typename\n    ... flexibleWysiwyg\n    ... flexibleFullwidthImage\n    ... flexibleFAQ\n    ... flexibleLinks\n    ... flexibleTextImage\n    ... flexibleVideo\n    ... flexibleLinkCards\n    ... flexibleTeamBlock\n    ... flexibleNews\n    ... flexibleProgrammes\n    ... flexibleCases\n    ... flexibleProminentText\n    ... flexibleImages\n    ... flexibleProjectsOrPortfolios\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleWysiwyg.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleFullwidthImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleFAQ.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleVideo.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleLinks.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleTextImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleLinkCards.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleTeamBlock.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleNews.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleProgrammes.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleCases.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleProminentText.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleImages.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/flexibleSections/flexibleProjectsOrPortfolios.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["flexibleSections"] = oneQuery(doc, "flexibleSections");
        
